<template>
  <div>
    <v-dialog v-model="dialog" persistent width="1220" scrollable>
      <v-card class="dialogheight">
        <v-card-title
          style="font-size: 20px;color: #363636;border: 1px solid #C0C0C0"
          class="pb-4"
        >
          <div>
            <v-icon class="mr-1" style="padding-bottom: 3px;"
              >mdi-square-edit-outline</v-icon
            >
            {{ $t("editsound") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$emit('close'), Cancel(), (fileError = false)"
            color="#424242"
            style="border-radius: 8px !important;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: 450px">
          <v-form ref="form" lazy-validation>
            <v-row class="mt-5">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="12">
                    <p style="color: #424242;font-size: 16px;">
                      {{ $t("createdateM") }}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {{ editData.createDate1 }} {{ $t("By") }}
                      {{ editData.createBy }}
                    </p>
                    <p
                      v-if="editData.updateBy != null"
                      style="color: #424242;font-size: 16px;"
                    >
                      {{ "Last Update" }}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {{ editData.updateDate1 }} {{ $t("By") }}
                      {{ editData.updateBy }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <label for="title" class="font-style">
                      {{ $t("title") }}
                      <span style="color: red">*</span>
                    </label>
                    <v-text-field
                      :rules="titleRules"
                      outlined
                      dense
                      hide-details="auto"
                      id="title"
                      v-model="editData.lessonName"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <label for="description" class="font-style">{{
                      $t("description")
                    }}</label>
                    <v-text-field
                      outlined
                      dense
                      hide-details="auto"
                      id="description"
                      v-model="editData.wordDescription"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    class="loading-circle"
                    color="green"
                  ></v-progress-circular>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" sm="6" lg="4" class="pt-4">
                    <input
                      type="file"
                      accept="audio/mp3"
                      class="d-none"
                      ref="sound"
                      @change="getsound"
                    />
                    <v-btn
                      color="#A6CC39"
                      style="font-size: 16px;float: left;border-radius: 8px;height: 40px;"
                      class="text-capitalize white--text btn_hover_effect"
                      width="190"
                      @click="$refs.sound.click()"
                    >
                      <v-icon class="mr-1">mdi-folder-search-outline</v-icon>
                      {{ $t("BrowseFile") }}
                    </v-btn>
                  </v-col>
                  <v-col class="pt-4" cols="12" md="6" sm="6" lg="7">
                    <div
                      style="font-size: 16px; color: #777777;word-break: break-word;width: 270px;"
                    >
                      <span>
                        {{ $t("RecommendFormatMP3") }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="7">
                    <p
                      class="text-left font-style"
                      :style="fileError ? { color: 'red' } : {}"
                    >
                      {{ $t("ImageCover") }}
                    </p>
                    <div>
                      <v-card
                        width="290"
                        height="215"
                        style="border: 4px dashed #C0C0C0;box-shadow: unset;
                    background: #F8F8F8 0% 0% no-repeat padding-box;"
                        @click="$refs.file.click()"
                        @dragover.prevent
                        @dragenter.prevent
                        @drop.prevent="dropImg($event)"
                      >
                        <v-img
                          :lazy-src="editData.pictureBackground"
                          :src="editData.pictureBackground"
                          @click="$refs.file.click()"
                          @mouseover="
                            editData.pictureBackground
                              ? (showEditImgTool = true)
                              : (showEditImgTool = false)
                          "
                          @mouseleave="
                            editData.pictureBackground
                              ? (showEditImgTool = false)
                              : (showEditImgTool = false)
                          "
                          :style="
                            fileError ? { border: '1px solid #FA5252' } : {}
                          "
                          width="240"
                          height="167"
                          style="border-radius: 8px !important;"
                          class="mx-auto center mt-4"
                          v-if="editData.pictureBackground != null"
                        >
                          <v-card-title
                            v-if="showEditImgTool"
                            style="left: 15%; top: 15%;position: absolute;"
                          >
                            <v-list
                              class="d-flex flex-column align-start"
                              style="padding: 0;border-radius: 8px;"
                            >
                              <v-list-item class="list-item-padding preview">
                                <v-btn
                                  color="#424242"
                                  style="font-size: 14px;width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click.stop="previewimg = true"
                                >
                                  <v-icon left>mdi-eye-outline</v-icon>
                                  {{ $t("preview") }}
                                </v-btn>
                              </v-list-item>

                              <v-list-item class="list-item-padding preview">
                                <v-btn
                                  color="error"
                                  style="font-size: 14px;width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click.stop="
                                    editData.pictureBackground = null
                                  "
                                >
                                  <v-icon left>mdi-delete-outline</v-icon>
                                  {{ $t("delete") }}
                                </v-btn>
                              </v-list-item>
                            </v-list>
                          </v-card-title>
                        </v-img>

                        <v-img
                          v-if="editData.pictureBackground == null"
                          src="@/assets/imgs/image_loader.png"
                          width="64"
                          height="52"
                          class="mx-auto center"
                          style="margin-top: 2.5rem;"
                          @click="$refs.file.click()"
                        ></v-img>
                        <input
                          type="file"
                          class="d-none"
                          ref="file"
                          accept="image/*"
                          @change="uploadImg($event, 1)"
                        />
                        <p
                          v-show="!editData.pictureBackground"
                          class="text-center mt-3"
                          style="color: #424242;font-size:14px;opacity: 0.6;margin-bottom: 0;"
                        >
                          {{ $t("DragDropfile") }}
                        </p>
                        <p
                          v-show="!editData.pictureBackground"
                          class="text-center"
                          style="color: #424242;font-size:14px;opacity: 0.6;"
                        >
                          {{ $t("OrBrowseFile") }} JPG"
                        </p>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="5">
                    <v-row>
                      <v-btn
                        color="#A6CC39"
                        style="font-size: 16px; margin-top: 3rem; float: left;border-radius: 8px;height: 40px;width: 165px;"
                        class="text-capitalize white--text btn_hover_effect"
                        @click="$refs.file.click()"
                      >
                        <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
                        {{ $t("AddCover") }}
                      </v-btn>
                      <p class="mt-3" style="color: #777777;font-size: 12px;">
                        {{ $t("RecommendFormatPNG") }}
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="soundHeaders"
                  :items="sounds"
                  hide-default-footer
                  :loading="soundLoading"
                  loading-text="Loading... Please wait"
                  :single-expand="true"
                  item-key="songName"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.part }}</td>
                      <td>{{ item.songName }}</td>
                      <td>{{ item.duration }}</td>
                      <td>
                        <div class="d-flex">
                          <v-menu open-on-hover offset-y min-width="55px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                width="55"
                                height="30"
                                color="#47484b"
                                class="text-capitalize mt-1 sort_Btn"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ item.sort }}
                                <v-icon
                                  style="margin-left: 0px;margin-right: -0.6rem;"
                                  >mdi-menu-down</v-icon
                                >
                              </v-btn>
                            </template>
                            <v-list
                              :style="
                                sounds.length == 1
                                  ? { height: '69px' }
                                  : sounds.length == 2
                                  ? { height: '103px' }
                                  : sounds.length == 3
                                  ? { height: '136px' }
                                  : sounds.length == 4
                                  ? { height: '170px' }
                                  : { height: '205px' }
                              "
                              class="overflow-y-auto"
                            >
                              <v-list-item
                                v-for="(temp, index) in sortNumberItems"
                                :key="index"
                                @click="item.sort = temp.value"
                              >
                                <!-- , changeSubmitSortNo(item) -->
                                <v-list-item-title class="custom_list_item">{{
                                  temp.value
                                }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </td>
                      <td style="text-align: center;">
                        <v-btn
                          color="#FF6060"
                          class="text-capitalize"
                          text
                          style="font-size: 16px"
                          @click="checkItemDelete(item)"
                        >
                          <v-icon class="mr-1">mdi-delete-outline</v-icon>
                          {{ $t("remove") }}
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-3 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize btnfont-style"
            style="border: 1px solid #C0C0C0;border-radius: 8px;color: #424242"
            text
            @click="$emit('close'), Cancel(), (fileError = false)"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btnfont-style btn_hover_effect"
            style="color: #ffff;border: 1px solid #A6CC39;border-radius: 8px;"
            color="#A6CC39"
            width="100"
            @click="submit()"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- cropimage -->
    <v-dialog
      v-model="dialogCrop"
      width="1000px"
      height="800px"
      overflow="hidden"
    >
      <v-card class="rounded-lg" overflow="hidden">
        <v-card-title
          class="white--text pb-4"
          style="background-color: #a6cc39; font-size: 30px"
          >Crop Image</v-card-title
        >
        <v-card-text
          class="pt-12"
          style="height: 550px; padding-left: 4rem; padding-right: 4rem"
        >
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
          ></vue-cropper>
        </v-card-text>
        <v-card-actions class="mt-3 pb-4" style="margin-right: 50px">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize btnfont-style"
            style="border: 1px solid #C0C0C0;border-radius: 8px;color: #424242"
            text
            @click="CancelCrop()"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btnfont-style btn_hover_effect"
            style="color: #ffff;border: 1px solid #A6CC39;border-radius: 8px;"
            color="#A6CC39"
            width="100"
            @click="CropImage()"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- preview image -->
    <v-dialog
      v-model="previewimg"
      persistent
      width="800px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important;">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="previewimg = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border:1px solid #FFFFFF30; "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="800px"
          height="500px"
          style="border-radius:8px; margin:auto;"
          :src="editData.pictureBackground"
        ></v-img>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" width="587" persistent>
      <v-card>
        <v-card-title
          style="font-size: 25px;color: #363636;"
          class="justify-start"
          >{{ $t("deleteconfirm") }}</v-card-title
        >

        <v-card-text>
          <p
            class="mt-5"
            style="
              font-size: 20px;
              color: #363636;
              opacity: 1;
              text-align: start;
            "
          >
            {{ $t("suredelete") }} ?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize mb-3"
            style="border: 1px solid #C0C0C0;border-radius: 8px;color: #424242;font-size: 20px"
            width="100"
            text
            @click="confirmDialog = false"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize mb-3"
            width="100"
            style="font-size: 20px;color:#ffffff"
            color="#FF6060"
            @click="deletesoundList()"
            >{{ $t("confirm") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueCropper } from "vue-cropper";
import store from "@/store";
import enurl from "@/api/environment";
import axios from "axios";

export default {
  components: {
    VueCropper
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    ActiveNumberOfFilesCount: Number,
    full_name: String
  },
  watch: {
    userSelected(val) {
      if (val.length != 0) {
        this.departmentSelected = [];
        this.isUser = true;
      }
    },
    departmentSelected(val) {
      if (val.length != 0) {
        this.userSelected = [];
        this.isUser = false;
      }
    },
    show(val) {
      if (val) {
        this.getSelectedSound();
      }
    }
  },
  computed: {
    ...mapGetters(["editData", "showFirstTimeEditDataForSound"]),
    timesRules() {
      return [v => !!v || ""];
    },
    dialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      }
    },
    soundHeaders() {
      return [
        {
          text: "#",
          sortable: false,
          value: "part"
        },
        {
          text: this.$t("File Name"),
          sortable: false,
          value: "songName"
        },
        {
          text: this.$t("Time"),
          sortable: false,
          value: "duration"
        },
        {
          text: this.$t("Sort"),
          align: "left",
          value: "sort"
        },
        {
          text: this.$t("action"),
          sortable: false,
          value: "actions",
          align: "center",
          width: "120px"
        }
      ];
    },
    titleRules() {
      return [v => !!v || "Title is required"];
    }
  },
  data: () => ({
    url: enurl.apiUrl,
    previewimg: false,
    expanded: [],
    soundPauses: [],
    soundPausesDialog: false,
    permissionChevron: false,
    showEditImgTool: false,
    sortNumberItems: [],
    perDayRules: {
      required: v => v.split("-").length > 2 || ""
    },
    dialogCrop: false,
    confirmDialog: false,
    loading: false,
    page: 1,
    pageCount: 0,
    userpage: 1,
    userpageCount: 0,
    deptpage: 1,
    deptpageCount: 0,
    option: {
      img: "",
      size: 1,
      full: false,
      outputType: "png",
      canMove: true,
      fixedBox: true,
      original: false,
      canMoveBox: false,
      autoCrop: true,
      autoCropWidth: 800,
      autoCropHeight: 450,
      centerBox: false,
      high: true
    },
    fileError: false,
    sound: {
      title: "",
      description: "",
      allow: false,
      file: null,
      fileUrl: "",
      fileName: ""
    },
    sounds: [],
    startDateMenu: false,
    endDateMenu: false,
    showPermission: false,
    listDialog: false,
    userSelected: [],
    departmentSelected: [],
    tabs: "tab-1",
    soundList: [],
    soundLoading: false,
    pauseSoundLoading: false,
    perList: [],
    userType: false,
    soundIndex: 0,
    userdataList: [],
    departmentdataList: [],
    allView: true,
    originalSongLength: 0,
    userNewLength: 0,
    PricingData: [],
    actualduration: null
  }),
  mounted() {},
  methods: {
    formatDuration(duration) {
      let time = [
        Math.floor(duration / 60) + "",
        Math.floor(duration % 60) + ""
      ];
      time.forEach(value => {
        while (value.length < 2) value = "0" + value;
      });
      return `${time[0]}:${time[1]}`;
    },
    editstartdateDis() {
      let that = this;
      that.startDateMenu = false;
      if (that.editStartDate > that.editEndDate) {
        that.editEndDate = that.editStartDate;
      }
    },
    dropImg(e) {
      let file = e.dataTransfer.files[0];
      if (!/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
        alert("Please choose image!");
        return false;
      }
      this.sound.fileName = file.name;
      let reader = new FileReader();
      reader.onload = f => {
        let src;
        if (typeof f.target.result === "object") {
          src = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          src = f.target.result;
        }
        this.option.img = src;
        this.dialogCrop = true;
      };
      reader.readAsArrayBuffer(file);
    },
    uploadImg(e, num) {
      let self = this;
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose image!");
        return false;
      }
      this.sound.fileName = file.name;
      let reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          self.option.img = data;
          self.dialogCrop = true;
        } else if (num === 2) {
          console.log("Something wrong");
        }
      };
      reader.readAsArrayBuffer(file);
    },
    CancelCrop() {
      this.dialogCrop = false;
    },
    CropImage() {
      this.$refs.cropper.getCropData(data => {
        this.getFile(data);
        this.dialogCrop = false;
      });
    },
    getSelectedSound() {
      this.sounds = this.editData.partfileList.map((v, i) => ({
        ...v,
        part: i + 1,
        index: i,
        duration: this.formatDuration(v.time),
        time: Math.trunc(v.time).toString(),
        permissionData: v.permissionData.map((u, j) => ({
          ...u,
          index: j
        }))
      }));
      this.originalSongLength = this.editData.partfileList.length;
      this.activeNumFiles_Count =
        this.activeNumFiles_Count - this.sounds.length;
      let temp_Item = this.sounds;
      let sort_temp1 = temp_Item
        .filter(x => x.sort != null && x.sort != 0)
        .map(v => ({
          ...v
        })); //sort number included array

      let sort_temp2 = temp_Item
        .filter(x => x.sort == null || x.sort == 0)
        .map(v => ({
          ...v
        })); //sort number un-included array

      sort_temp1.sort((a, b) => {
        if (a.sort === b.sort) {
          return a.sort < b.sort ? -1 : 1;
        } else {
          return a.sort < b.sort ? -1 : 1;
        }
      }); //sort by selected sort numberr...
      //sort_temp2.sort((a, b) => (a.duration > b.duration ? 1 : -1)); //sortb by topic tiltes...

      this.sounds = sort_temp1.concat(sort_temp2).map((v, i) => ({
        ...v,
        no: i + 1,
        part: parseInt(i + 1) //"Part " +
      }));

      let temp_null = [{ value: "" }];
      let temp_num = this.sounds.map((v, i) => {
        return { value: i + 1 };
      });
      this.sortNumberItems = temp_null.concat(temp_num);
    },
    allowedStartDates: val => val >= new Date().toISOString().substr(0, 10),
    allowedEndDates(val) {
      return val >= this.sound.startDate;
    },
    allowedPerday(val) {
      return val <= this.editEndDate && val >= this.editStartDate;
    },
    checkStatus(item) {
      if (item) {
        if (item.includes("T")) {
          return item.split("T")[0];
        } else {
          return item;
        }
      } else {
        return "Please Select"; //Date Picker
      }
    },
    getFile(e) {
      this.sound.fileUrl = e;
      this.sound.file = e;
      this.editData.pictureBackground = e;
      this.showEditImgTool = false;
    },

    imageTobase64(fileObject) {
      const reader = new FileReader();
      reader.onload = e => {
        this.sound.file = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },

    async getsound(e) {
      this.soundLoading = true;
      let filesize = e.target.files[0].size;

      if (filesize <= 157286400) {
        const audio = document.createElement("audio");
        audio.addEventListener("loadedmetadata", () => {
          console.log("Duration:", audio.duration);
          this.actualduration = audio.duration;
        });
        audio.src = URL.createObjectURL(e.target.files[0]);
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        const res = await axios.post(`${this.url}File/UploadFile`, formData);
        this.sounds.push({
          isUserGroup: this.isUser ? 2 : 1,
          permissionData: [],
          file: res.data.data,
          songName: e.target.files[0].name,
          part: parseInt(this.originalSongLength + 1), //"Part " +
          index: parseInt(this.originalSongLength + 1),
          duration: this.formatDuration(this.actualduration),
          time: Math.trunc(this.actualduration).toString(),
          allView: true
        });
        this.showsoundList = true;
        this.originalSongLength = this.originalSongLength + 1;

        let temp_Item = this.sounds;
        //sorting....
        let sort_temp1 = temp_Item
          .filter(x => x.sort != null && x.sort != 0)
          .map(v => ({
            ...v
          })); //sort number included array

        let sort_temp2 = temp_Item
          .filter(x => x.sort == null || x.sort == 0)
          .map(v => ({
            ...v
          })); //sort number un-included array

        sort_temp1.sort((a, b) => {
          if (a.sort === b.sort) {
            return a.sort < b.sort ? -1 : 1;
          } else {
            return a.sort < b.sort ? -1 : 1;
          }
        }); //sort by selected sort numberr...

        this.sounds = sort_temp1.concat(sort_temp2).map((v, i) => ({
          ...v,
          no: i + 1,
          part: parseInt(i + 1) //"Part " +
        }));

        let temp_null = [{ value: "" }];
        let temp_num = this.sounds.map((v, i) => {
          return { value: i + 1 };
        });
        this.sortNumberItems = temp_null.concat(temp_num);
      } else {
        alert("Your file size is over 150MB!");
      }
      this.soundLoading = false;
      e.target.value = null;
    },

    getsoundDuration(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const media = new Audio(reader.result);
          media.onloadedmetadata = () => resolve(media.duration);
        };
        reader.readAsDataURL(file);
        reader.onerror = error => reject(error);
      });
    },
    async checkItemDelete(item) {
      let self = this;
      self.confirmDialog = true;
      self.soundIndex = item.index;
    },
    deletesoundList() {
      this.sounds.splice(
        this.sounds.findIndex(item => item.index === this.soundIndex),
        1
      );
      let index = this.sortNumberItems.length - 1;
      this.sortNumberItems.splice(index, 1);
      this.sounds = this.sounds.map((x, i) => ({
        ...x,
        part: i + 1
      }));
      this.confirmDialog = false;
      if (this.sounds.length == 0) {
        this.showsoundList = false;
        this.showPermission = false;
      }
    },
    Cancel() {
      this.showSelectedList = false;
      this.originalSongLength = 0;
      this.expanded = [];
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const base64Res = await axios.post(
          `${this.url}File/UploadFileStringBase`,
          {
            base64: this.sound.file,
            fileName: this.sound.fileName
          }
        );

        let partlist = [];
        for (let v of this.sounds) {
          partlist.push({
            id: v.id,
            videoLessonID: v.videoLessonID,
            videoFile: v.file,
            songName: v.songName,
            time: v.time,
            sort: v.sort == "" ? null : v.sort
          });
        }

        const data = {
          id: this.editData.id,
          lessonName: this.editData.lessonName,
          wordDescription: this.editData.wordDescription,
          startContentDate: this.editStartDate,
          endContentDate: this.editEndDate,
          allowDownload: false,
          partfileList: partlist,
          companyId: store.getters.companyid,
          picturebackground: base64Res.data,
          imgBase64: this.sound.file,
          topicID: this.editData.topicID,
          updateBy: this.full_name
        };
        const res = await axios.post(
          `${this.url}Video/UpdateVideoContentFromProductAdmin`,
          data
        );
        if (res.data.status == 0) {
          this.$emit("confirm");
          this.userType = false;
          this.perList = [];
          this.sounds = [];
          this.originalSongLength = 0;
        }
        this.expanded = [];
      } else {
        this.fileError = true;
        alert("Incomplete information Please enter again!");
        this.expanded = [];
      }
      this.loading = false;
      this.expanded = [];
    }
  }
};
</script>

<style scoped>
.loading-circle {
  position: fixed;
  z-index: 5;
  right: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
}
::v-deep .v-dialog {
  border-radius: 10px !important;
}
::v-deep .preview_class.v-dialog {
  border-radius: 8px !important;
}
::v-deep .v-text-field__slot {
  font-size: 16px !important;
}

.font-style {
  font-size: 16px;
  color: #4d4f5c;
}

::v-deep .v-input__slot {
  border-radius: 10px !important;
}

::v-deep .sound-table tr:nth-child(even) {
  background: unset;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 16px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
}

::v-deep .primary--text {
  color: #a6cc39 !important;
}
::v-deep .primary {
  background-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .accent {
  background-color: #a6cc39 !important;
}
::v-deep .accent--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
}

::v-deep .v-tab--active {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
}
/* >>> .v-simple-checkbox .v-icon {
  color: #a6cc39 !important;
} */
::v-deep .v-simple-checkbox .mdi-checkbox-blank-outline {
  color: #c0c0c0 !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-marked {
  color: #a6cc39 !important;
}
::v-deep .v-simple-checkbox .mdi-minus-box {
  color: #a6cc39 !important;
}
::v-deep .chkAllow .v-label {
  font-size: 18px !important;
}
.btnfont-style {
  font-size: 20px;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  /* opacity: 1; */
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* For Sort menu. */
::v-deep .sort_Btn.v-btn:not(.v-btn--round).v-size--default {
  min-width: 50px;
  font-size: 18px;
  padding: 0 0;
  border: 1px solid #47484b;
  opacity: 1 !important;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar {
  width: 7px !important;
}
/* Track */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-track {
  width: 6px !important;
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}
/* Handle */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 2px #e6e6e6;
  border-radius: 7px;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}
::v-deep .v-list-item {
  min-height: 32px;
  /* border-bottom: 1px solid #707070; */
  border-top: 2px solid #707070;
}
::v-deep .v-list-item:hover {
  background-color: #707070 !important;
}
::v-deep
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  color: #ffffff !important;
}
/* end sort menu. */
.list-item-padding.v-sheet.v-list {
  border-radius: 8px !important;
}
.list-item-padding.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  border-radius: 8px !important;
}
.list-item-padding.list-item-padding.theme--light {
  padding: 0 5px !important;
  min-height: 42px !important;
}
::v-deep .list-item-padding.preview.v-list-item.theme--light {
  border-top: unset !important;
}
::v-deep .list-item-padding.v-list-item:hover {
  background-color: unset !important;
}
</style>

<style scoped>
::v-deep
  .child_table.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 16px !important;
  color: #424242 !important;
  background-color: rgb(166, 204, 57, 0.2) !important;
  opacity: 1;
}
::v-deep
  .child_table.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #424242 !important;
  background-color: #ffffff !important;
  opacity: 1;
  vertical-align: center;
}
::v-deep .v-data-table thead th:first-child {
  border-radius: 8px 0 0 8px;
} /**.child_table */
::v-deep .v-data-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: unset !important;
}
.dialogheight {
  height: 750px !important;
}
</style>
